module.exports = __webpack_public_path__ + "static/media/info-icon.05bd58e7.svg";